// WaitTimes.js

import React, { useState, useEffect } from "react";
import axios from "axios";

function WaitTimes() {
  const [waitTimes, setWaitTimes] = useState({
    tunnel: { general: null, nexus: null },
    bridge: { general: null, nexus: null },
  });
  const [expandedRow, setExpandedRow] = useState(null);

  useEffect(() => {
    const fetchWaitTimes = async () => {
      try {
        const tunnelUrl =
          "https://bwt.cbp.gov/api/bwtRss/rssbyportnum/HTML/POV/380002";
        const bridgeUrl =
          "https://bwt.cbp.gov/api/bwtRss/rssbyportnum/HTML/POV/380001";
        const [tunnelRes, bridgeRes] = await Promise.all([
          axios.get(tunnelUrl, { responseType: "text" }),
          axios.get(bridgeUrl, { responseType: "text" }),
        ]);
        const parser = new DOMParser();
        const parseData = (xmlText) => {
          const xmlDoc = parser.parseFromString(xmlText, "text/xml");
          const item = xmlDoc.getElementsByTagName("item")[0];
          const result = { general: null, nexus: null };

          if (item) {
            const desc =
              item.getElementsByTagName("description")[0].textContent;

            // Parse General Lanes directly from description
            const generalMatch = desc.match(
              /General Lanes:\s*At (.+?) (\d+) min delay (\d+) lane\(s\) open/,
            );
            if (generalMatch) {
              result.general = {
                time: generalMatch[1],
                delay:
                  parseInt(generalMatch[2]) === 0
                    ? "No delay"
                    : `${generalMatch[2]} min`,
                lanes: `${generalMatch[3]} lane(s)`,
              };
            }

            // Parse Nexus Lanes directly from description
            const nexusMatch = desc.match(
              /Nexus Lanes:\s*At (.+?) (\d+) min delay (\d+) lane\(s\) open/,
            );
            if (nexusMatch) {
              result.nexus = {
                time: nexusMatch[1],
                delay:
                  parseInt(nexusMatch[2]) === 0
                    ? "No delay"
                    : `${nexusMatch[2]} min`,
                lanes: `${nexusMatch[3]} lane(s)`,
              };
            } else if (
              desc.includes("Nexus Lanes:") &&
              desc.includes("Lanes Closed")
            ) {
              result.nexus = {
                time: "N/A",
                delay: "Closed",
                lanes: "0 lanes",
              };
            }
          }

          return result;
        };
        const tunnelData = parseData(tunnelRes.data);
        const bridgeData = parseData(bridgeRes.data);
        setWaitTimes({ tunnel: tunnelData, bridge: bridgeData });
      } catch (error) {
        console.error("Error fetching wait times:", error);
        setWaitTimes({
          tunnel: {
            general: { time: "Error", delay: "Error", lanes: "Error" },
            nexus: { time: "Error", delay: "Error", lanes: "Error" },
          },
          bridge: {
            general: { time: "Error", delay: "Error", lanes: "Error" },
            nexus: { time: "Error", delay: "Error", lanes: "Error" },
          },
        });
      }
    };
    fetchWaitTimes();
    if (window.gtag && window.consented)
      window.gtag("event", "tool_view", { tool: "wait_times" });
  }, []);

  return (
    <section className="utility canada-theme us-theme">
      <h2>Border Wait Times</h2>
      <table className="wait-times-table">
        <thead>
          <tr>
            <th>Route</th>
            <th>Type</th>
            <th>Lanes</th>
            <th>Wait</th>
          </tr>
        </thead>
        <tbody>
          {/* Tunnel General Lanes */}
          <tr
            onClick={() =>
              setExpandedRow(
                expandedRow === "tunnel-general" ? null : "tunnel-general",
              )
            }
            style={{ cursor: "pointer" }}
          >
            <td>US Tunnel</td>
            <td>General</td>
            <td>
              {waitTimes.tunnel.general
                ? waitTimes.tunnel.general.lanes.split(" ")[0]
                : "N/A"}
            </td>
            <td>
              {waitTimes.tunnel.general
                ? waitTimes.tunnel.general.delay
                : "N/A"}
            </td>
          </tr>
          {expandedRow === "tunnel-general" && waitTimes.tunnel.general && (
            <tr className="expanded-row">
              <td
                colSpan="4"
                style={{
                  padding: "8px",
                  backgroundColor: "rgba(255,255,255,0.05)",
                  fontSize: "0.8em",
                }}
              >
                Updated at {waitTimes.tunnel.general.time}
              </td>
            </tr>
          )}

          {/* Tunnel Nexus Lanes */}
          <tr
            onClick={() =>
              setExpandedRow(
                expandedRow === "tunnel-nexus" ? null : "tunnel-nexus",
              )
            }
            style={{ cursor: "pointer" }}
          >
            <td>US Tunnel</td>
            <td>Nexus</td>
            <td>
              {waitTimes.tunnel.nexus
                ? waitTimes.tunnel.nexus.lanes.split(" ")[0]
                : "N/A"}
            </td>
            <td>
              {waitTimes.tunnel.nexus ? waitTimes.tunnel.nexus.delay : "N/A"}
            </td>
          </tr>
          {expandedRow === "tunnel-nexus" && waitTimes.tunnel.nexus && (
            <tr className="expanded-row">
              <td
                colSpan="4"
                style={{
                  padding: "8px",
                  backgroundColor: "rgba(255,255,255,0.05)",
                  fontSize: "0.8em",
                }}
              >
                Updated at {waitTimes.tunnel.nexus.time}
              </td>
            </tr>
          )}

          {/* Bridge General Lanes */}
          <tr
            onClick={() =>
              setExpandedRow(
                expandedRow === "bridge-general" ? null : "bridge-general",
              )
            }
            style={{ cursor: "pointer" }}
          >
            <td>US Bridge</td>
            <td>General</td>
            <td>
              {waitTimes.bridge.general
                ? waitTimes.bridge.general.lanes.split(" ")[0]
                : "N/A"}
            </td>
            <td>
              {waitTimes.bridge.general
                ? waitTimes.bridge.general.delay
                : "N/A"}
            </td>
          </tr>
          {expandedRow === "bridge-general" && waitTimes.bridge.general && (
            <tr className="expanded-row">
              <td
                colSpan="4"
                style={{
                  padding: "8px",
                  backgroundColor: "rgba(255,255,255,0.05)",
                  fontSize: "0.8em",
                }}
              >
                Updated at {waitTimes.bridge.general.time}
              </td>
            </tr>
          )}

          {/* Bridge Nexus Lanes */}
          <tr
            onClick={() =>
              setExpandedRow(
                expandedRow === "bridge-nexus" ? null : "bridge-nexus",
              )
            }
            style={{ cursor: "pointer" }}
          >
            <td>US Bridge</td>
            <td>Nexus</td>
            <td>
              {waitTimes.bridge.nexus
                ? waitTimes.bridge.nexus.lanes.split(" ")[0]
                : "N/A"}
            </td>
            <td>
              {waitTimes.bridge.nexus ? waitTimes.bridge.nexus.delay : "N/A"}
            </td>
          </tr>
          {expandedRow === "bridge-nexus" && waitTimes.bridge.nexus && (
            <tr className="expanded-row">
              <td
                colSpan="4"
                style={{
                  padding: "8px",
                  backgroundColor: "rgba(255,255,255,0.05)",
                  fontSize: "0.8em",
                }}
              >
                Updated at {waitTimes.bridge.nexus.time}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}

export default WaitTimes;
